class ContentDbMulti extends HTMLElement {
	constructor() {
		super();
		this.desktopContainer = null;
		this.mobileContainer = null;
		this.leftButton = null;
		this.rightButton = null;
		this.isScrolling = false;
		this.currentIndex = 0;
		this.isMobile = false;
		this.items = [];
		this.touchStartX = 0;
		this.touchStartY = 0;
		this.isHorizontalScroll = false;
	}

	connectedCallback() {
		this.checkMobile();
		this.initializeElements();
		this.loadData();
		this.setupEventListeners();
		this.handleResize();
	}

	checkMobile() {
		this.isMobile = window.innerWidth < 1024; // lg断点
	}

	handleResize() {
		window.addEventListener('resize', () => {
			const wasMobile = this.isMobile;
			this.checkMobile();
			if (wasMobile !== this.isMobile) {
				this.initializeElements();
				this.updateNavigationState();
			}
		});
	}

	initializeElements() {
		this.desktopContainer = this.querySelector(
			'.desktop-container .content-container'
		);
		this.mobileContainer = this.querySelector(
			'.mobile-container .content-container'
		);
		this.leftButton = this.querySelector('.left-button');
		this.rightButton = this.querySelector('.right-button');
	}

	loadData() {
		const dataAttr = this.getAttribute('data-items');
		if (dataAttr) {
			try {
				this.items = JSON.parse(decodeURIComponent(dataAttr));
			} catch (e) {
				console.error('Invalid data-items attribute:', e);
				this.items = [];
			}
		}
		this.updateNavigationState();
	}

	setupEventListeners() {
		if (this.isMobile) {
			this.setupMobileEventListeners();
		} else {
			this.setupDesktopEventListeners();
		}
	}

	setupDesktopEventListeners() {
		if (this.leftButton) {
			this.leftButton.addEventListener('click', () => this.scrollLeft());
		}
		if (this.rightButton) {
			this.rightButton.addEventListener('click', () => this.scrollRight());
		}
	}

	setupMobileEventListeners() {
		const slider = this.querySelector('.content-db-multi-mobile-slider');
		const dots = this.querySelectorAll('[data-content-db-multi-dot]');

		if (!slider || !dots.length) return;

		// 处理滑动事件
		let isScrolling = false;
		slider.addEventListener('scroll', () => {
			if (isScrolling) return;

			isScrolling = true;
			requestAnimationFrame(() => {
				const scrollLeft = slider.scrollLeft;
				const containerWidth = slider.offsetWidth;
				const slideWidth = containerWidth * 0.96; // 96% 宽度
				const newSlide = Math.round(scrollLeft / slideWidth);

				if (newSlide !== this.currentIndex) {
					this.currentIndex = newSlide;
					this.updatePaginationDots();
				}

				isScrolling = false;
			});
		});

		// 处理导航点点击
		dots.forEach((dot, index) => {
			dot.addEventListener('click', () => {
				this.currentIndex = index;
				const containerWidth = slider.offsetWidth;
				const slideWidth = containerWidth * 0.96;
				slider.scrollTo({
					left: slideWidth * index,
					behavior: 'smooth'
				});
				this.updatePaginationDots();
			});
		});

		// 添加触摸滑动支持
		this.addTouchSupport(slider);
	}

	addTouchSupport(slider) {
		// 获取所有可能需要滚动的元素
		const scrollableElements = slider.querySelectorAll(
			'.content-db-multi-mobile-slide'
		);

		scrollableElements.forEach((element) => {
			element.addEventListener('touchstart', (e) => this.handleTouchStart(e), {
				passive: true
			});
			element.addEventListener('touchmove', (e) => this.handleTouchMove(e), {
				passive: false
			});
			element.addEventListener('touchend', (e) => this.handleTouchEnd(e), {
				passive: true
			});
		});

		// 也给slider本身添加事件监听
		slider.addEventListener('touchstart', (e) => this.handleTouchStart(e), {
			passive: true
		});
		slider.addEventListener('touchmove', (e) => this.handleTouchMove(e), {
			passive: false
		});
		slider.addEventListener('touchend', (e) => this.handleTouchEnd(e), {
			passive: true
		});
	}

	handleTouchStart(e) {
		this.touchStartX = e.touches[0].clientX;
		this.touchStartY = e.touches[0].clientY;
		this.isHorizontalScroll = null;
	}

	handleTouchMove(e) {
		if (!this.touchStartX || !this.touchStartY) return;

		const touchX = e.touches[0].clientX;
		const touchY = e.touches[0].clientY;
		const deltaX = this.touchStartX - touchX;
		const deltaY = this.touchStartY - touchY;

		// 如果还没有确定滚动方向
		if (this.isHorizontalScroll === null) {
			// 确定主要的滚动方向
			this.isHorizontalScroll = Math.abs(deltaX) > Math.abs(deltaY);
		}

		// 如果是水平滚动，阻止默认行为
		if (this.isHorizontalScroll) {
			e.preventDefault();
		}
	}

	handleTouchEnd(e) {
		if (!this.touchStartX || !this.isHorizontalScroll) return;

		const touchEndX = e.changedTouches[0].clientX;
		const deltaX = this.touchStartX - touchEndX;
		const threshold = 50; // 最小滑动距离

		if (Math.abs(deltaX) > threshold && this.isHorizontalScroll) {
			const slider = this.querySelector('[data-content-db-multi-slider]');
			if (!slider) return;

			const containerWidth = slider.offsetWidth;
			const slideWidth = containerWidth * 0.96;

			if (deltaX > 0 && this.currentIndex < this.items.length - 1) {
				// 向左滑动，下一张
				this.currentIndex++;
			} else if (deltaX < 0 && this.currentIndex > 0) {
				// 向右滑动，上一张
				this.currentIndex--;
			}

			slider.scrollTo({
				left: slideWidth * this.currentIndex,
				behavior: 'smooth'
			});
			this.updatePaginationDots();
		}

		// 重置触摸状态
		this.touchStartX = null;
		this.touchStartY = null;
		this.isHorizontalScroll = null;
	}

	scrollToSlide(index) {
		const slider = this.querySelector('#mobileSlider');
		if (!slider) return;

		const containerWidth = slider.offsetWidth;
		const slideWidth = containerWidth * 0.96; // 96% 宽度
		slider.scrollTo({
			left: slideWidth * index,
			behavior: 'smooth'
		});
	}

	bindPaginationEvents() {
		// 这个方法现在在 setupMobileEventListeners 中处理
	}

	handlePaginationClick(e) {
		// 这个方法现在在 setupMobileEventListeners 中处理
	}

	updatePaginationDots(activeIndex = null) {
		const currentIndex = activeIndex !== null ? activeIndex : this.currentIndex;
		const dots = this.querySelectorAll('[data-content-db-multi-dot]');

		dots.forEach((dot, index) => {
			if (index === currentIndex) {
				dot.classList.add('active');
				dot.style.background = 'linear-gradient(45deg, #6366f1, #8b5cf6)';
				dot.classList.remove('bg-gray-600');
			} else {
				dot.classList.remove('active');
				dot.style.background = '';
				dot.classList.add('bg-gray-600');
			}
		});
	}

	getContainerWidth(isMobile = false) {
		const container = isMobile
			? this.querySelector('.content-db-multi-mobile-slider')
			: this.querySelector('.desktop-container .overflow-hidden');

		if (container) {
			return container.offsetWidth;
		}
		return 0;
	}

	getItemWidth(isMobile = false) {
		if (isMobile) {
			// 移动端：获取实际的slide宽度
			const slide = this.querySelector('.content-db-multi-mobile-slide');
			if (slide) {
				return slide.offsetWidth;
			}
			// 如果无法获取实际宽度，则计算 96% 的容器宽度
			const containerWidth = this.getContainerWidth(true);
			return containerWidth * 0.96;
		} else {
			return this.getContainerWidth(false);
		}
	}

	getGap(isMobile = false) {
		if (isMobile) {
			const contentContainer = this.querySelector(
				'.mobile-container .content-container'
			);
			if (contentContainer) {
				const contentStyle = window.getComputedStyle(contentContainer);
				return parseFloat(contentStyle.gap) || 0;
			}
		}
		return 0;
	}

	getMaxScroll() {
		const containerWidth = this.getContainerWidth(true);
		const itemWidth = this.getItemWidth(true);
		const gap = this.getGap(true);

		// 计算总宽度：项目宽度 * 数量 + gap * (数量-1)
		const totalItemsWidth =
			itemWidth * this.items.length + gap * Math.max(0, this.items.length - 1);

		// 获取content-container的左padding
		const contentContainer = this.querySelector(
			'.mobile-container .content-container'
		);
		let leftPadding = 0;
		if (contentContainer) {
			const contentStyle = window.getComputedStyle(contentContainer);
			leftPadding = parseFloat(contentStyle.paddingLeft);
		}

		// 最大滚动距离
		return Math.min(0, containerWidth - totalItemsWidth - leftPadding);
	}

	updateNavigationState() {
		// 桌面端：显示或隐藏导航按钮
		if (!this.isMobile) {
			const navigationContainer = this.querySelector(
				'.desktop-container .flex.justify-center.mt-8'
			);
			if (navigationContainer) {
				navigationContainer.style.display =
					this.items.length > 1 ? 'flex' : 'none';
			}
		} else {
			// 移动端：显示或隐藏分页点
			const paginationContainer = this.querySelector('.pagination-dots');
			if (paginationContainer) {
				paginationContainer.style.display =
					this.items.length > 1 ? 'flex' : 'none';
			}
			this.updatePaginationDots();
		}
	}

	scrollLeft() {
		if (this.isScrolling) return;
		const targetIndex = Math.max(this.currentIndex - 1, 0);
		this.scrollToIndex(targetIndex, false);
	}

	scrollRight() {
		if (this.isScrolling) return;
		const targetIndex = Math.min(this.currentIndex + 1, this.items.length - 1);
		this.scrollToIndex(targetIndex, false);
	}

	scrollToIndex(index, isMobile = false) {
		if (isMobile) {
			const containerWidth = this.getContainerWidth(true);
			const itemWidth = this.getItemWidth(true);
			const gap = this.getGap(true);

			// 获取content-container的左padding
			const contentContainer = this.querySelector(
				'.mobile-container .content-container'
			);
			let leftPadding = 0;
			if (contentContainer) {
				const contentStyle = window.getComputedStyle(contentContainer);
				leftPadding = parseFloat(contentStyle.paddingLeft);
			}

			// 计算项目应该居中显示的位置
			// 项目中心位置 = leftPadding + index * (itemWidth + gap) + itemWidth/2
			// 可视区域中心位置 = containerWidth / 2
			// 所以需要滚动的距离 = 可视区域中心 - 项目中心
			const itemCenterPosition =
				leftPadding + index * (itemWidth + gap) + itemWidth / 2;
			const viewportCenter = containerWidth / 2;
			const targetTransform = viewportCenter - itemCenterPosition;

			const maxScroll = this.getMaxScroll();
			const finalTransform = Math.max(Math.min(targetTransform, 0), maxScroll);

			this.animateScroll(finalTransform, true);
		} else {
			// 桌面端：滚动完整内容项
			const containerWidth = this.getContainerWidth(false);
			const targetTransform = -index * containerWidth;
			this.animateScroll(targetTransform, false);
		}

		this.currentIndex = index;
	}

	getCurrentTransform(isMobile = false) {
		const container = isMobile ? this.mobileContainer : this.desktopContainer;
		if (!container) return 0;

		const transform = container.style.transform;
		const match = transform.match(/translateX\((-?\d+(?:\.\d+)?)px\)/);
		return match ? parseFloat(match[1]) : 0;
	}

	animateScroll(targetX, isMobile = false) {
		this.isScrolling = true;
		const container = isMobile ? this.mobileContainer : this.desktopContainer;

		if (container) {
			container.style.transition = 'transform 0.3s ease-out';
			container.style.transform = `translateX(${targetX}px)`;
		}

		setTimeout(() => {
			this.isScrolling = false;
			if (container) {
				container.style.transition = '';
			}
			// 动画完成后更新分页点状态
			if (isMobile) {
				this.updatePaginationDots();
			}
		}, 300);
	}

	static get observedAttributes() {
		return ['data-items'];
	}

	attributeChangedCallback(name, oldValue, newValue) {
		if (name === 'data-items' && oldValue !== newValue) {
			this.loadData();
		}
	}
}

customElements.define('content-db-multi', ContentDbMulti);
